<script>
export default {
	data() {
		return {
			currentStep: 0, // This keeps track of the current step
			steps: [
				{ title: "Licence" },
				{ title: "System Requirements" },
				{ title: "Folder Permission" },
				{ title: "Database" },
				{ title: "Admin" },
        	],
		}
	},
	methods: {
		goToNextStep() {
				// Check if there is a next step
				if (this.currentStep < this.steps.length) {
				this.currentStep += 1;
			}
		},
		goToPreviousStep() {
				// Check if there is a previous step
				if (this.currentStep > 0) {
				this.currentStep -= 1;
			}
		},
    },
}
</script>

<template>
    <div class="installation-header">
        <div class="container">
            <div>
                <img src="@/assets/img/logo.svg" alt="Logo" class="img-fluid">
            </div>
        </div>
    </div>

    <div class="project-installation">
        <div class="content p-0">
            <div class="container">
                <div class="row">
                    <div class="col-lg-10 mx-auto">
                        <div class="wizard">
                            <ul class="form-wizard-steps" id="progressbar2">
                                <li :class="['progress-active', { 'active ': currentStep === 0 , 'progress-activated' : currentStep > 0 }]">
                                    <div class="profile-step">
                                        <span class="profile-box"><img src="@/assets/img/icons/install-icon-01.svg" alt="image"></span>
                                        <div class="step-section">
                                            <h5>Licence</h5>
                                        </div>
                                        <span class="dot-active"></span>
                                    </div>
                                </li>
                                <li :class="[{ 'progress-active' : currentStep === 1 , 'progress-activated' : currentStep > 1 }]">
                                    <div class="profile-step">
                                        <span class="profile-box"><img src="@/assets/img/icons/install-icon-02.svg" alt="image"></span>
                                        <div class="step-section">
                                            <h5>System Requirements</h5>
                                        </div>
                                        <span class="dot-active"></span>
                                    </div>
                                </li>
                                <li :class="[{ 'progress-active' : currentStep === 2 , 'progress-activated' : currentStep > 2 }]">
                                    <div class="profile-step">
                                        <span class="profile-box"><img src="@/assets/img/icons/install-icon-03.svg" alt="image"></span>
                                        <div class="step-section">
                                            <h5>Folder Permission</h5>
                                        </div>
                                        <span class="dot-active"></span>
                                    </div>
                                </li>
                                <li :class="[{ 'progress-active' : currentStep === 3 , 'progress-activated' : currentStep > 3 }]">
                                    <div class="profile-step">
                                        <span class="profile-box"><img src="@/assets/img/icons/install-icon-04.svg" alt="image"></span>
                                        <div class="step-section">
                                            <h5>Database</h5>
                                        </div>
                                        <span class="dot-active"></span>
                                    </div>
                                </li>
                                <li :class="[{ 'progress-active' : currentStep === 4 , 'progress-activated' : currentStep > 4 }]">
                                    <div class="profile-step">
                                        <span class="profile-box"><img src="@/assets/img/icons/install-icon-05.svg" alt="image"></span>
                                        <div class="step-section">
                                            <h5>Admin</h5>
                                        </div>
                                        <span class="dot-active"></span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="initialization-form-set">
                            <fieldset class="form-inner card wizard-form-card" id="first" v-show="currentStep === 0">
                                <div class="licence-verifi">
                                    <div class="card-title">
                                        <h4>Purchase Verification</h4>
                                        <p>Activate your purchase code for this domain</p>
                                    </div>
                                    <form>
                                        <div class="install-step">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="mb-3">
                                                        <label class="form-label">Envato User ID</label>
                                                        <input type="text" class="form-control">
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="mb-3 mb-0">
                                                        <label class="form-label">Purchase Code</label>
                                                        <input type="text" class="form-control">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="add-form-btn widget-next-btn submit-btn">
                                    <div class="btn-left">
                                        <a href="javascript:void(0);" class="btn btn-primary main-btn pre-btn disabled"><i class="feather-arrow-left"></i>Prev</a>
                                    </div>
                                    <div class="btn-left">
                                        <a href="javascript:void(0);" @click="goToNextStep" class="btn btn-primary main-btn next_btns">Next <i class="feather-arrow-right"></i></a>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset class="form-inner card wizard-form-card" :class="currentStep === 1 ? 'd-block' : 'd-none'">
                                <div class="system-verifi">
                                    <div class="card-title">
                                        <h4>System Requirement</h4>
                                        <p>Required Elements to installl tuelysell into your System</p>
                                    </div>
                                    <div class="install-step">
                                        <div class="requirment-field">
                                            <div class="elements-name"><i class="fa-regular fa-circle-check"></i>Php Version</div>
                                            <span class="version">8.2.4</span>
                                        </div>
                                        <div class="requirment-field">
                                            <div class="elements-name"><i class="fa-regular fa-circle-check"></i>Curl PHP Extension</div>
                                            <span class="version">Enable</span>
                                        </div>
                                        <div class="requirment-field">
                                            <div class="elements-name"><i class="fa-regular fa-circle-check"></i>File info PHP Extension</div>
                                            <span class="version">Enable</span>
                                        </div>
                                        <div class="requirment-field">
                                            <div class="elements-name"><i class="fa-regular fa-circle-check"></i>Mb String PHP Extension</div>
                                            <span class="version">Enable</span>
                                        </div>
                                        <div class="requirment-field">
                                            <div class="elements-name"><i class="fa-regular fa-circle-xmark"></i>GD PHP Extension</div>
                                            <span class="error-msg">Disabled (You Need to Eable “GD” Extension on Your Serrver)</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="add-form-btn widget-next-btn submit-btn">
                                    <div class="btn-left">
                                        <a href="javascript:void(0);" @click="goToPreviousStep" class="btn btn-primary main-btn prev_btns"><i class="feather-arrow-left"></i>Prev</a>
                                    </div>
                                    <div class="btn-left">
                                        <a href="javascript:void(0);" @click="goToNextStep" class="btn btn-primary main-btn next_btns">Next <i class="feather-arrow-right"></i></a>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset class="form-inner card wizard-form-card" :class="currentStep === 2 ? 'd-block' : 'd-none'">
                                <div class="folder-permission">
                                    <div class="card-title">
                                        <h4>Folder Permission</h4>
                                        <p>Permissions to the folders</p>
                                    </div>
                                    <div class="install-step">
                                        <ul class="files-list">
                                            <li>
                                                <span class="folder"><i class="fa-regular fa-folder-open"></i>Application / Config</span>
                                                <span><i class="fa-regular fa-circle-check"></i></span>
                                            </li>
                                            <li>
                                                <span class="folder"><i class="fa-regular fa-folder-open"></i>Upload / Audios</span>
                                                <span><i class="fa-regular fa-circle-check"></i></span>
                                            </li>
                                            <li>
                                                <span class="folder"><i class="fa-regular fa-folder-open"></i>Upload / blocks</span>
                                                <span><i class="fa-regular fa-circle-check"></i></span>
                                            </li>
                                            <li>
                                                <span class="folder"><i class="fa-regular fa-folder-open"></i>Upload / blog</span>
                                                <span><i class="fa-regular fa-circle-check"></i></span>
                                            </li>
                                            <li>
                                                <span class="folder"><i class="fa-regular fa-folder-open"></i>Upload / Category</span>
                                                <span><i class="fa-regular fa-circle-check"></i></span>
                                            </li>
                                            <li>
                                                <span class="folder"><i class="fa-regular fa-folder-open"></i>Upload / digital-files</span>
                                                <span><i class="fa-regular fa-circle-check"></i></span>
                                            </li>
                                            <li>
                                                <span class="folder"><i class="fa-regular fa-folder-open"></i>Upload / Images</span>
                                                <span><i class="fa-regular fa-circle-check"></i></span>
                                            </li>
                                            <li>
                                                <span class="folder"><i class="fa-regular fa-folder-open"></i>Upload / image-file-manager</span>
                                                <span><i class="fa-regular fa-circle-check"></i></span>
                                            </li>
                                            <li>
                                                <span class="folder"><i class="fa-regular fa-folder-open"></i>Upload / logo</span>
                                                <span><i class="fa-regular fa-circle-check"></i></span>
                                            </li>
                                            <li>
                                                <span class="folder"><i class="fa-regular fa-folder-open"></i>Upload / Profile</span>
                                                <span><i class="fa-regular fa-circle-check"></i></span>
                                            </li>
                                            <li>
                                                <span class="folder"><i class="fa-regular fa-folder-open"></i>Upload / Support</span>
                                                <span><i class="fa-regular fa-circle-check"></i></span>
                                            </li>
                                            <li>
                                                <span class="folder"><i class="fa-regular fa-folder-open"></i>Upload / Temp</span>
                                                <span><i class="fa-regular fa-circle-check"></i></span>
                                            </li>
                                            <li>
                                                <span class="folder"><i class="fa-regular fa-folder-open"></i>Upload / Video</span>
                                                <span><i class="fa-regular fa-circle-check"></i></span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="add-form-btn widget-next-btn submit-btn">
                                    <div class="btn-left">
                                        <a href="javascript:void(0);" @click="goToPreviousStep" class="btn btn-primary main-btn prev_btns"><i class="feather-arrow-left"></i>Prev</a>
                                    </div>
                                    <div class="btn-left">
                                        <a href="javascript:void(0);" @click="goToNextStep" class="btn btn-primary main-btn next_btns">Next <i class="feather-arrow-right"></i></a>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset class="form-inner card wizard-form-card" :class="currentStep === 3 ? 'd-block' : 'd-none'">
                                <div class="folder-permission">
                                    <div class="card-title">
                                        <h4>Database</h4>
                                        <p>Detail of your database</p>
                                    </div>
                                    <form>
                                        <div class="install-step">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="mb-3">
                                                        <label class="form-label">Host</label>
                                                        <input type="text" class="form-control">
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="mb-3">
                                                        <label class="form-label">Database Name</label>
                                                        <input type="text" class="form-control">
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="mb-3">
                                                        <label class="form-label">Username</label>
                                                        <input type="text" class="form-control">
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="mb-3 mb-0">
                                                        <label class="form-label">Password</label>
                                                        <input type="password" class="form-control">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="add-form-btn widget-next-btn submit-btn">
                                    <div class="btn-left">
                                        <a href="javascript:void(0);" @click="goToPreviousStep" class="btn btn-primary main-btn prev_btns"><i class="feather-arrow-left"></i>Prev</a>
                                    </div>
                                    <div class="btn-left">
                                        <a href="javascript:void(0);" @click="goToNextStep" class="btn btn-primary main-btn next_btns">Next <i class="feather-arrow-right"></i></a>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset class="form-inner card wizard-form-card" :class="currentStep === 4 ? 'd-block' : 'd-none'">
                                <div class="folder-permission">
                                    <div class="card-title">
                                        <h4>Admin Account</h4>
                                        <p>Username & Password of Your Account</p>
                                    </div>
                                    <form>
                                        <div class="install-step">
                                            <table class="install-user">
                                                <tr>
                                                    <td>Username</td>
                                                    <td>: admin</td>
                                                </tr>
                                                <tr>
                                                    <td>Email</td>
                                                    <td>: admin@domain.com</td>
                                                </tr>
                                                <tr>
                                                    <td>Password</td>
                                                    <td>: 1234</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </form>
                                    <div class="rechange-details">
                                        <span>You can change username, email, password from the profile setting section after the installation </span>
                                    </div>
                                </div>
                                <div class="add-form-btn widget-next-btn submit-btn">
                                    <div class="btn-left">
                                        <a href="javascript:void(0);" @click="goToPreviousStep" class="btn btn-primary main-btn prev_btns"><i class="feather-arrow-left"></i>Prev</a>
                                    </div>
                                    <div class="btn-left">
                                        <router-link to="/home/" class="btn btn-primary main-btn next_btns">Finish <i class="feather-arrow-right"></i></router-link>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div class="installation-footer py-4 text-center">
                            <p>Copyright ⓒ 2024 Truelysell - All Rights Reserved.</p>
                        </div>
                    </div>			
                </div>			
            </div>			
        </div>
    </div>
</template>